export * from './terminologyKeys'

export const previewModeKey = 'wl_preview_mode'
export const previewModeRegex = /wl_preview_mode=([^&]*)?&?/
